import { Directive, ElementRef, HostListener, inject } from '@angular/core';

@Directive({
  selector: '[evcHorizontalWheelScroll]',
  standalone: true,
})
export class HorizontalWheelScrollDirective {
  #el = inject(ElementRef);

  @HostListener('wheel', ['$event'])
  onWheel(event: WheelEvent): void {
    event.preventDefault();
    const factor = 30;
    this.#el.nativeElement.scrollLeft += event.deltaY < 0 ? -factor : factor;
  }
}
